import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const SUMMARY_MODAL_OPEN = "onSummaryModalOpen";
export const SHOW_CONTENT_MODAL_OPEN = "onShowContentModalOpen";
